//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading } from 'grommet';
import { DashboardGridProd, DashboardGridITG, DashboardFooter } from '.';

export const Home = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page background="background-back">
      <PageContent>

          <PageHeader title="Hello" size="medium" pad={{ top: 'small' }} margin={{ top: 'medium' }}
            subtitle={`Welcome to the Explorer community!`}/>

          <Heading size="small" margin={{ top: 'large' }}>HPE IT Spotlight:</Heading>

          <DashboardGridProd /> 

          <Heading size="small" margin={{ top: 'large' }}>Additional info:</Heading>

          <DashboardGridITG /> 
          
          <DashboardFooter/>

      </PageContent>  

    </Page>
  );
};